import React from 'react'
import styled from 'styled-components';
import { TextInput } from '../../styles/reusables';
import { MainButton, BackButton } from '../../styles/buttons';
import { submitForm } from '../../utils/formFunctions';


const Container = styled.form`
    max-width: 500px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    width: 100%;

    button {
        max-width: 250px;
        margin: 20px auto;
    }
`;

const Wrapper = styled.div`
width: 100%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
padding: 0 20px;

> button {
	max-width: 400px;
	width: 100%;
	margin-top: 20px;

}
`;


const ExistingUser = ({ setStep }) => {

		const [state, setState] = React.useState({email: '', phone: '', storeUrl: '', fullName: ''})
		
    const handleChange = (e) => {
      setState({ ...state, [e.target.name]: e.target.value })
    }
  
    const handleSubmit = (e) => {

			e.preventDefault();
			const form = e.target
			const formName = form.getAttribute('name');
			const formAction = form.getAttribute('action');
			submitForm(state, formName, formAction)

    }

    return (
			<Wrapper>
        <Container
						name="existing-user"
						method="POST"
						action="/success"
						onSubmit={handleSubmit}
        >
						<input type="hidden" name="bot-field" />
            <input type="hidden" name="form-name" value="existing-user" />
            
            <TextInput onChange={handleChange} name="fullName" type="text" placeholder="Enter Full Name" value={state.fullName}/>
            <TextInput onChange={handleChange} name="email" type="email" placeholder="Email address" value={state.email}/>
            <TextInput onChange={handleChange} name="storeUrl" type="text" placeholder="Shopify store URL" value={state.storeUrl} />
            <TextInput onChange={handleChange} name="phone" placeholder="Phone number" value={state.phone}/>
            <MainButton type="submit">Submit</MainButton>
        </Container>

				<BackButton onClick={() => setStep(1)} >Go Back</BackButton>
			</Wrapper>
    )
}

export default ExistingUser